import { debounce } from 'lodash';

function sendEvent(category, action, label, value) {
  if (ga) {
    ga('send', 'event', category, action, label, value);
  }
}

exports.gaEvent = function gaEvent(wait = 500) {
  return (debounce(sendEvent, wait));
}



// WEBPACK FOOTER //
// ./shared/lib/googleAnalytics.js